<template>
  <div>
    <div
      class="background-image-login"
      :style="[ client && client.loginImage ? {'backgroundImage': 'url(' + client.loginImage + ') center no-repeat'} : {'backgroundImage': 'url(img/temp/cook.jpg)'}]"
    ></div>

    <!-- Header -->
    <div class="header py-8 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-3">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Forgot Password</h1>
              <p class="text-lead text-white">Enter your email below. If an account is found that matches, a reset link will be emailed to you.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    label="Email Address"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-email-83"
                    placeholder="example@email.com"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    v-model="model.email"
                  >
                  </base-input>
                  <!-- <b-row class=" my-4" v-if="formTerms">
                    <b-col cols="12">
                      <base-input :rules="{ required: { allowFalse: false } }" name="Privacy" Policy>
                        <b-form-checkbox v-model="model.agree">
                          <span class="text-muted"
                            >I agree with the <a href="/privacy-policy">Privacy Policy</a></span
                          >
                        </b-form-checkbox>
                      </base-input>
                    </b-col>
                  </b-row> -->
                  <div class="text-center">
                    <b-button type="submit" variant="primary">{{
                        submitting ? "Submitting..." : "Submit"
                      }}</b-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

import swal from 'sweetalert2';

export default {
  name: 'forgot-password',
  data() {
    return {
      model: {
        email: ''
      }
    };
  },
  computed: {
     client() {
      return this.$store.state.clients.current;
    },
    submitting() {
      return this.$store.state.authentication.status.submitting;
    },
    registerError() {
      return this.$store.state.authentication.status.error;
    },
    errorMessage() {
      return this.$store.state.alert.message;
    },
    formCompleted() {
      return Object.values(this.model).every(Boolean)
    }
  },
  created() {
    this.$store.state.alert.message = '';

    var urlParams = new URLSearchParams(window.location.search);
    var client = urlParams.get('host');
    
    let $this = this.$store;
    $this.dispatch("clients/getCurrentClient", client)
    setTimeout(function() {
      $this.dispatch("settings/getSettings", $this.state.clients.current.id);
    }, 2500);
  },
  methods: {
    onSubmit(e) {
    const { dispatch } = this.$store;
      if (this.formCompleted) {
        try {
            dispatch("authentication/forgotPassword", this.model)
                .then(response => {
                      swal.fire({
                        title: 'Sent!',
                        text: `Your request has been sent. Check your email to reset your password.`,
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false,
                      });
            }).catch(error => {
                console.log('Something went wrong: ', error);
            });
        } catch (error) {
            console.log("Error: forgotPassword", error);
        }
      }
    }
  }
};
</script>
<style></style>
